import { useAvailableRoles } from '@/composables/queries/useAvailableRoles';
import type { PermissionGroup } from '@/types/composition-functions';

/**
 * The school's available roles mapped into select options, plus the query's
 * loading state. Shared by every role picker (invite dialogs, role requests)
 * so the mapping exists in exactly one place.
 */
export function useRoleOptions() {
  const { availableRolesResult, loadingAvailableRoles: loadingRoles } = useAvailableRoles(true);

  const roleOptions = computed(() =>
    (availableRolesResult.value?.getAvailableRoles ?? []).map((r: PermissionGroup) => ({
      label: r.name,
      value: r.id,
    })),
  );

  return { roleOptions, loadingRoles };
}
